import React from 'react';
import AuthService from '../../../services/auth.service';
import { Spinner, Alert } from '../../../services/notiflix.service';
import { GoogleSvgIcon } from '../IconProvider';
import { useTranslation } from 'react-i18next';
const GoogleSignup = () => {
  const { t } = useTranslation('auth');
  const loginGoogle = async () => {
    Spinner.show();
    try {
      let resp = await AuthService.socialSignInRequest('google');

      if (resp.status === 'failure') {
        Spinner.hide();
        Alert.error(resp.message);
        return false;
      }

      Spinner.hide();
      window.location.href = resp?.data;
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
    }
  };
  return (
    <button
      onClick={() => loginGoogle()}
      className="border border-[#F3F3F3] text-[#85919F] bg-white rounded-md flex items-center py-3 px-7"
    >
      <GoogleSvgIcon /> {t('google')}
    </button>
  );
};

export default GoogleSignup;
